module.exports = __webpack_public_path__ + "static/mission-a2495cf212f030a10cab2aa5044d7588.png";